import './Footer.sass';
import FadeIn from '../../Components/Motion/FadeIn.js';
import Resume from '../../Components/Images/resume.pdf';
import { GitHubIcon, LinkedInIcon, DocumentIcon } from '../../Components/Icons/Icons.js';

function ShowSocials() {
  const s = [
    { name: 'Resume', link: Resume, icon: <DocumentIcon /> },
    { name: 'GitHub', link: 'https://github.com/bryan-bee', icon: <GitHubIcon /> },
    { name: 'LinkedIn', link: 'https://www.linkedin.com/in/bryan-bee/', icon: <LinkedInIcon /> },
  ];

  return (
    <div className="footer_socials">
      {s.map((i) => (
        <a className="footer_socials_button fs1" href={i.link} target="_blank" rel="noopener noreferrer" key={i.name}>
          {i.icon} {i.name}
        </a>
      ))}
    </div>
  );
}

function Footer() {
  return (
    <div className="footer_main">
      <FadeIn className="footer">
        <a className="footer_name fs3" href="#page1"><b>Bryan Bee</b></a>
        <div className="footer_text fs1">Thanks for visiting!</div>

        <ShowSocials />

        <a className="footer_totop fs1" href="#page1">Back to top ↑</a>
      </FadeIn>
    </div>
  );
}

export default Footer;
